import styled from '@emotion/styled';
import toast from 'react-hot-toast';
import { deleteEstimateApi } from '~/api';
import Button from '~/components/Button';
import Gap from '~/components/Gap';
import ModalWrapper from '~/components/ModalWrapper';
import ModalHeader from '~/components/ModalWrapper/ModalHeader';
import Text from '~/components/Text';
import { useSelector } from '~/store';
import { selectBusinessUuid } from '~/store/slices/formSlice/selectors';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';

interface IDeleteEstimateProps {
  estimateUuid: string | null;
  handleClose(): void;
}

const Wrapper = styled.div`
  background: var(--white);
  border-radius: 12px;
  padding: 16px;
`;

const DeleteEstimate = ({ estimateUuid, handleClose }: IDeleteEstimateProps) => {
  const businessUuid = useSelector(selectBusinessUuid);

  async function handleSubmit() {
    if (!estimateUuid) {
      toast.error('Estimate ID is missing!');
      return;
    }

    const promise = await deleteEstimateApi(businessUuid, estimateUuid);
    const response = await apiResponseHandler(promise);

    if (response.type !== ApiResponseEnum.Success) {
      toast.error(response.error.toString());
    } else {
      toast.success('Estimate deleted successfully!');
      handleClose();
    }
  }

  return (
    <ModalWrapper isVisible={!!estimateUuid} modalWidth="400px" handleClose={handleClose}>
      <Wrapper className="full-width">
        <ModalHeader handleClose={handleClose} headerJsx="" />

        <Text size="sm" className="bold">
          Delete estimate
        </Text>
        <Gap t={12} />

        <Text size="xs">
          Are you sure you want to delete this estimate? Once deleted, this estimate will no longer
          be accessible.
        </Text>

        <Gap t={24} />

        <div className="align-center">
          <Button className="full-width" variant="secondary" size="md" onClick={handleClose}>
            Cancel
          </Button>

          <Gap l={12} />

          <Button variant="danger" className="full-width" size="md" onClick={handleSubmit}>
            Delete
          </Button>
        </div>
      </Wrapper>
    </ModalWrapper>
  );
};

export default DeleteEstimate;
